const Subscription = Object.freeze({
  nothin: 0,
  plans: 1,
  subscribe: 2,
  upgrade: 3,
});

export default Subscription;
